angular.module('app.services').service('usersService', function (api) {
    const Service = this;

    const array_combine = (keys, values) => {
        const result = {};

        if ('object' !== typeof keys || 'object' !== typeof values || !keys.length || keys.length !== values.length) {
            return {};
        }

        for (let i = 0; i < keys.length; ++i) {
            result[keys[i]] = values[i];
        }

        return result;
    };

    Service._model = api('users');

    Service.getAll = () => Service._model.list().then((response) => response.data);

    Service.selectize = (userOptions) => {
        const defaultOptions = {
            data: {
                all: 0,
            },
            transform: {
                id: 'id',
                value: ':fullname (:job.value)',
                area_id: 'area_id',
            },
        };

        const options = angular.extend({}, defaultOptions, userOptions);

        return Service._model.selectize(options).then((response) => response.data);
    };

    Service.find = (id) => Service._model.get(id).then(this.transform);

    Service.transform = (userData) => {
        userData.permissions_id = array_combine(userData.permissions_id, userData.permissions_id);
        userData.groups_id = array_combine(userData.groups_id, userData.groups_id);

        return userData;
    };

    Service.save = (user) => Service._model.post(user);
});
